import { useState } from "react";

const MAX_VISIBLE_CHARS = 300;

interface ErrorMessageProps {
  message: string;
}

/**
 * Displays an error message with truncation for long errors.
 * Shows the first N characters by default with a toggle to reveal the rest.
 * @param message - The error string to display
 */
export default function ErrorMessage({ message }: ErrorMessageProps) {
  const [expanded, setExpanded] = useState(false);

  const isTruncatable = message.length > MAX_VISIBLE_CHARS;
  const visibleText =
    isTruncatable && !expanded
      ? message.slice(0, MAX_VISIBLE_CHARS) + "…"
      : message;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <p className="text-sm text-red-700 whitespace-pre-wrap leading-relaxed">
        {visibleText}
      </p>
      {isTruncatable && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-2 text-xs font-semibold text-red-600 hover:text-red-800 transition-colors"
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}
